import apiService from "./apiService";
import {
  ChartResolution,
  DeviceChartData,
  DeviceChartType,
} from "../models/chartData";

export interface ChartQuery {
  resolution: ChartResolution;
  from: string;
  to: string;
}

export default class ChartService {
  static async fetchMdbnChartData(
    moduleId: number,
    query: ChartQuery,
  ): Promise<DeviceChartData> {
    const response = await apiService.fetchEntity<{ data: DeviceChartData }>(
      `/modules/${moduleId}/chart-data`,
      { params: query },
    );
    return response.data.data;
  }

  static async fetchMmbChartData(
    moduleId: number,
    query: ChartQuery,
  ): Promise<DeviceChartData> {
    const response = await apiService.fetchEntity<{ data: DeviceChartData }>(
      `/modules/${moduleId}/chart-data-mmb`,
      { params: query },
    );
    return response.data.data;
  }

  static async fetchSmbChartData(
    moduleId: number,
    query: ChartQuery,
  ): Promise<DeviceChartData> {
    const response = await apiService.fetchEntity<{ data: DeviceChartData }>(
      `/modules/${moduleId}/chart-data-smb`,
      { params: query },
    );
    return response.data.data;
  }

  static fetchChartData(
    moduleId: number,
    deviceType: DeviceChartType,
    query: ChartQuery,
  ): Promise<DeviceChartData> {
    switch (deviceType) {
      case "mdbn":
        return ChartService.fetchMdbnChartData(moduleId, query);
      case "mmb":
        return ChartService.fetchMmbChartData(moduleId, query);
      case "smb":
        return ChartService.fetchSmbChartData(moduleId, query);
    }
  }
}
